import { render, staticRenderFns } from "./grandlisy.vue?vue&type=template&id=6d3ccce4"
import script from "./grandlisy.vue?vue&type=script&lang=js"
export * from "./grandlisy.vue?vue&type=script&lang=js"
import style0 from "./grandlisy.vue?vue&type=style&index=0&id=6d3ccce4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports